export const linkableFragment = /* GraphQL */ `
  fragment linkable on _Linkable {
    _linkType
    ... on _ExternalLink {
      url
    }
    ... on _FileLink {
      url
      name
      size
    }
    ... on _Document {
      _meta {
        id
        uid
        type
        lang
      }
    }
    ... on _ImageLink {
      url
    }
    ... on Page {
      parent {
        ... on Page {
          _meta {
            uid
            type
          }
        }
      }
    }
  }
`

export const linkableFragmentNoPage = /* GraphQL */ `
  fragment linkableNoPage on _Linkable {
    _linkType
    ... on _ExternalLink {
      url
    }
    ... on _FileLink {
      url
      name
      size
    }
    ... on _Document {
      _meta {
        id
        uid
        type
        lang
      }
    }
    ... on _ImageLink {
      url
    }
  }
`
